export const EVENT_EMITTER_KEY: unique symbol = Symbol('Event Emitter');

export const EVENT_EMIT_KEY: unique symbol = Symbol('Emit Event');
